import React, { useEffect, useReducer, useRef, ReactNode  } from "react";

// Interface for component props
interface ReportsBodyRightProps {
	children?: ReactNode;
}

export const ReportsBodyRight = ( props: ReportsBodyRightProps ) => {

	return(
		<div className={"reports-body-right"}>
			{
				props.children
			}
		</div>
	);
};